import {PlusLoadConfiguration, PlusLoadForm} from '../../../../fields/plusLoad/types'
import {CreateFormInput} from '../types'

export const buildPlusLoadForm = ({
  order
}: CreateFormInput<PlusLoadConfiguration>): PlusLoadForm => {
  const schedule = order.schedules[0]
  return {
    plusLoadExpected: schedule.quantityChangeExpected ?? false
  }
}
